<template>
	<div class="flex-grow rounded-lg" :class="padding">
		<div>
			<div class="flex w-full justify-between">
				<div class="flex-grow flex items-center space-x-4 justify-between">
					<div class="flex space-x-4 items-center">
						<slot name="preTitle"></slot>
						<h3 :class="styleText" class="text-left text-connectProBlue font-bold">{{ title }}</h3>
					</div>
					<div class="flex space-x-4 pr-2 pb-2">
						<slot name="afterTitle"></slot>
						<font-awesome-icon :icon="['fas', 'question-circle']" class="cursor-pointer text-xl" size="lg" @click="showHint" v-if="hint" />
						<font-awesome-icon :icon="['fas', 'times']" class="cursor-pointer text-xl" @click="$emit('close')" v-if="isModal" />
					</div>
				</div>

				<div class="flex space-x-4">
					<slot name="icons" />
					<button
						@click="$emit('clickCreate')"
						v-if="isCreateNew"
						:title="iconAddTitle"
						class="bg-sp btn block btn-overview-edit flex items-center justify-center text-white"
					>
						<font-awesome-icon :icon="['fas', 'plus']"></font-awesome-icon>
					</button>
					<button
						@click="$emit('clickEdit')"
						v-else-if="isEditable || isViewable"
						:title="iconTitle"
						class="bg-sp btn block btn-overview-edit flex items-center justify-center text-white"
					>
						<font-awesome-icon :icon="['fas', isViewable ? 'eye' : 'edit']"></font-awesome-icon>
					</button>
					<font-awesome-icon
						v-if="isToggleable"
						:icon="['fas', isCardEnabled ? 'angle-up' : 'angle-down']"
						@click="toggleCard"
						class="cursor-pointer"
					/>
				</div>
			</div>
		</div>
		<div class="text-left pt-6" :class="{ 'h-0 overflow-hidden': !isCardEnabled }">
			<slot>
				<LoadingSpinner />
			</slot>
		</div>
	</div>
</template>

<script>
import LoadingSpinner from '@/components/navigation/LoadingSpinner';
export default {
	name: 'BaseCard',
	components: { LoadingSpinner },
	props: {
		hint: { type: String },
		title: {
			type: String,
			required: true,
		},
		styleText: { default: 'text-xl' },
		padding: { default: 'p-6' },
		isCreateNew: { type: Boolean, default: false },
		isEditable: { type: Boolean, default: false },
		isViewable: { type: Boolean, default: false },
		isToggleable: { type: Boolean, default: false },
		isToggleOpen: { type: Boolean, default: true },
		isModal: { type: Boolean, default: false },
	},
	computed: {
		isCardEnabled() {
			return this.isToggleOpen;
		},
		iconTitle() {
			return this.title + ' ' + this.$t('edit_low');
		},
		iconAddTitle() {
			return this.title + ' ' + this.$t('add').toLowerCase();
		},
	},
	methods: {
		toggleCard() {
			this.$emit('toggleCard', !this.isToggleOpen);
		},
		showHint() {
			this.$swal(this.$t('general.hint').toString(), this.hint, 'info');
		},
	},
};
</script>

<style scoped></style>
